import { SystemService } from "./SystemService";
import AuthService from "./AuthService";
import { v4 } from 'uuid';

class OffersService{

    systemService = null;
    api = null;
    authService = null;

    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getOffers(search, customerId, page, perPage){
        const getOffersPromise = new Promise((resolve, reject) => {
            let user = this.authService.getUser();
            let config = this.authService.getConfig();
            let sessionid = this.authService.getSessionId();
            if(!user){
                throw "Δεν είστε συνδεδεμένος";
            }
            if(!config){
                throw "Δεν έχετε επιλέξει Α/Χ";
            }
            this.api.get(`offers?wh=${config.whCode}&search=${search}&page=${page}&perPage=${perPage}&customerId=${customerId}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        })
        return getOffersPromise;
    }

    getOffer(offerId){
        const getOfferPromise = new Promise((resolve, reject) => {
            let user = this.authService.getUser();
            let config = this.authService.getConfig();
            let sessionid = this.authService.getSessionId();
            if(!user){
                throw "Δεν είστε συνδεδεμένος";
            }
            if(!config){
                throw "Δεν έχετε επιλέξει Α/Χ";
            }
            this.api.get(`offers/offer/${offerId}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        })
        return getOfferPromise;
    }

    getCustomers(search){
        const getCustomersPromise = new Promise((resolve, reject) => {
            let user = this.authService.getUser();
            let config = this.authService.getConfig();
            let sessionid = this.authService.getSessionId();
            if(!user){
                throw "Δεν είστε συνδεδεμένος";
            }
            if(!config){
                throw "Δεν έχετε επιλέξει Α/Χ";
            }
            this.api.get(`offers/customers/${config.company}?search=${search}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        });
        return getCustomersPromise;
    }

    createOffers(customers, offer, offerItems){
        const promises = [];
        offer.code = v4();
        let user = this.authService.getUser();
        let config = this.authService.getConfig();
        offer.wh = config.whCode;
        let sessionid = this.authService.getSessionId();
        for(let i = 0; i < customers.length; i ++){
            promises.push(new Promise((resolve, reject) => {
                offer.customerId = customers[i];
                this.api.post('offers', {offer, offerItems}, { headers: { authorization: sessionid } }).then(r => resolve(r.data)).catch(e => reject(e));
            }));
        }
        return promises;
    }

    syncToErp(offerId){
        let user = this.authService.getUser();
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        const syncToErpPromise = new Promise((resolve, reject) => {
            this.api.post(`offers/sync/${offerId}`, {}, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        });
        return syncToErpPromise;
    }

    getPrices(){
        let user = this.authService.getUser();
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        const getPricesPromise = new Promise((resolve, reject) => {
            this.api.get(`offers/prices/${config.whCode}`, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        });
        return getPricesPromise;
    }

    getStock(){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let stockPromise = new Promise((resolve, reject) => {
            this.api.get(`offers/stock/${config.whCode}`, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return stockPromise;
    }

    getDeliveryTerms(){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let deliveryTermsPromise = new Promise((resolve, reject) => {
            this.api.get(`offers/terms/${config.whCode}`, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return deliveryTermsPromise;
    }

    getTermPrices(){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let termPricesPromise = new Promise((resolve, reject) => {
            this.api.get(`offers/costsPerTerm/${config.whCode}`, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return termPricesPromise;
    }

    createTermPrices(termPrices){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let createTermPricesPromise = new Promise((resolve, reject) => {
            this.api.post(`offers/costsPerTerm/${config.whCode}`, termPrices, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return createTermPricesPromise;
    }
    
    getPackages(){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        return new Promise((resolve, reject) => {
            this.api.get(`offers/packages/${config.whCode}`, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
    }
    
    savePackage(offerPackage){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let createPackagePromise = new Promise((resolve, reject) => {
            this.api.post(`offers/packages`, {...offerPackage, whCode: config.whCode}, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return createPackagePromise;
    }
    
    updatePackage(offerPackage){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let updatePackagePromise = new Promise((resolve, reject) => {
            this.api.put(`offers/packages/${offerPackage.id}`, offerPackage, {
                headers: {
                  authorization: sessionid
                }
            })
        });
        return updatePackagePromise;
    }
    
    deactivatePackage(offerPackage){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let deactivatePackagePromise = new Promise((resolve, reject) => {
            this.api.delete(`offers/packages/${offerPackage.id}`, {
                headers: {
                  authorization: sessionid
                }
            })
        });
        return deactivatePackagePromise;
    }
}

export default OffersService;